import { FieldWrapper } from '@progress/kendo-react-form';
import React from 'react'; 

const CusAddBtn = (props) => {
    const {id, label,disabled} = props;
    return(
        <FieldWrapper>
        <div className="row around-xs inputPair elementVisible">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <button id={id} className="box" style={{borderStyle:'none',background:'white'}}
                disabled={disabled}
                onClick={ e => {
                        e.preventDefault();
                        props.onClick();
                    }}>
          
                <span className="k-icon k-i-plus-outline" style={{fontSize:'24px', color:'grey'}}></span>
                <span> {label}</span>
            </button>
        </div>
        </div>
        </FieldWrapper>
    )
}

export default CusAddBtn;